<!--
<app-smallscreens *ngIf="sidenavService.isPhone() && isLoggedIn && false"></app-smallscreens>
-->
<!--
{{isLoggedIn}} {{userService.account?.id}}
-->

@if (isLoggedIn) {
	<app-topbar [isLoggedIn]="isLoggedIn" [accounts]="accountsForTopbar" [userAccount]="userAccount"></app-topbar>
}

<mat-sidenav-container
	autosize
	[ngClass]="{
		'logged-in-layout': isLoggedIn && !isTerminal,
		'logged-out-layout': !isLoggedIn,
	}">
	@if (isLoggedIn && !sidenavService.isPhone() && !isTerminal) {
		<mat-sidenav #leftSideNav class="example-sidenav set-min-width" [mode]="sidenavService.isTablet() ? 'over' : 'side'" [opened]="(!sidenavService.isTablet() || sidenavService.isMobileMenuOpened()) && !!selectedService" id="left-sidenav" [ngClass]="{ 'set-min-width-expanded': isExpanded }" [disableClose]="true">
			<mat-nav-list class="dashboard" style="margin-top: 12px; height: 100%; display: flex; flex-direction: column">
				<div class="scrollable-menu">
					@for (item of leftSidebarMenuItemsFromChild; track item) {
						<app-menu-list-item
							[expanded]="getExpandedStatusOnPageLoad(item)"
							[item]="item"
							[isExpanded]="isExpanded"
							(newElementEvent)="selectItem($event, item)"
							[overlay]="item.overlay"
							class="mat-caption"
							[ngClass]="{
								itemSelected: (isReportSelected && item.overlay) || (isAdminSelected && item.children.length >= 0),
							}"></app-menu-list-item>
					}
					<mat-divider></mat-divider>
				</div>
				<div class="toggle-button" [ngClass]="{ 'align-toogle-right': isExpanded }">
					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="setLang('da')">
							<span>{{ 'general.language.danish' | translate }}</span>
						</button>
						<button mat-menu-item (click)="setLang('en')">
							<span>{{ 'general.language.english' | translate }}</span>
						</button>
						<button mat-menu-item (click)="setLang('reset')">
							<span>{{ 'general.language.reset' | translate }}</span>
						</button>
					</mat-menu>
					<mat-icon svgIcon="{{ isExpanded ? 'acies_collapse' : 'acies_expand' }}" (click)="toggleSideBarExpanded()">menu_open</mat-icon>
				</div>
			</mat-nav-list>
		</mat-sidenav>
	}

	<mat-sidenav
		#rightSideNav
		[position]="sidenavService.isPhone() ? 'end' : 'end'"
		[mode]="sidenavService.isPhone() ? 'over' : 'side'"
		opened="false"
		class="right-sidebar"
		[ngClass]="{
			'right-sidebar-collapsed': sidenavService.isPhone() ? false : !rightIsExpanded,
			'set-min-width-expanded': sidenavService.isPhone() ? false : rightIsExpanded && isLoggedIn,
		}"
		[disableClose]="true">
		<ng-container #rightSideNavWidgetContent></ng-container>
	</mat-sidenav>

	<section class="subcomponent-outer-wrap">
		<!--<router-outlet (activate)="onActivate($event)"></router-outlet>-->
		<router-outlet></router-outlet>
	</section>
</mat-sidenav-container>
